import React, {useEffect, useState} from "react";
import classNames from "classnames";
import styles from "./CopyField.module.scss";
import {ReactComponent as CopyIcon} from "../../images/monochrome-icons/ic-copy.svg";
import {ReactComponent as DownloadIcon} from "../../images/monochrome-icons/download-icon.svg";
import {CSSTransition} from "react-transition-group";
import ReactDOM from "react-dom";
import {CopyToClipboard} from "react-copy-to-clipboard";
import _ from "lodash";
import FormFieldInputNew from "../Forms/FormFieldInputNew"
import FormFieldInputButton from "../Forms/FormFieldInputButton"


const DownloadButton = ({downloadContent, fileName}) => {
    return (<a
            href={`data:text/json;charset=utf-8,${encodeURIComponent(
                JSON.stringify(downloadContent)
            )}`}
            download={`${fileName}.json`}>
            <FormFieldInputButton Icon={DownloadIcon}/>
        </a>)
}

const CopyButton = ({text: _text}) => {
    const [showBubble, setShowBubble] = useState(false);
    const [bubblePosition, setBubblePosition] = useState({});
    const buttonRef = React.createRef();
    const bubbleRef = React.createRef();
    const text = _.isObject(_text) ? JSON.stringify(_text, null, 4) : _text;

    useEffect(() => {
        if (showBubble && buttonRef.current) {
            const {top, left, width} = buttonRef.current.getBoundingClientRect();
            const maxWidth = document.body.clientWidth;
            let isLeft = false;
            if (left + width + 60 > maxWidth) {
                isLeft = true;
            }

            setBubblePosition({top: top - 50, left: left + (isLeft ? 0 : width), isLeft})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showBubble]);

    return <CopyToClipboard text={text} onCopy={() => {
        setShowBubble(true);
        setTimeout(() => {
            setShowBubble(false);
        })
    }}>
        <span ref={buttonRef}>
            <FormFieldInputButton Icon={CopyIcon}>
                <CSSTransition nodeRef={bubbleRef} in={showBubble} unmountOnExit timeout={1000}>
                        <span ref={bubbleRef}>
                            {ReactDOM.createPortal(<div
                                className={classNames(styles['bubble'], {[styles['left']]: bubblePosition.isLeft})}
                                style={{top: bubblePosition.top, left: bubblePosition.left}}>Copied to
                                clipboard</div>, document.body)}
                        </span>
                </CSSTransition>
            </FormFieldInputButton>
        </span>
    </CopyToClipboard>
}

export default ({text: _text, className, style, label, download}) => {
    return (
        <FormFieldInputNew style={style} value={_text} className={classNames(className, styles["input"])} label={label} inputButtons={
            <>
                <CopyButton text={_text}/>
                {download && <DownloadButton downloadContent={download.content} fileName={download.fileName}/>}
            </>
        }/>
    )
};
